import TableModel from './table.model'

let storeContent = utils.generateStore({
   TableModel,
   tables: [],
   selected_tables: [],
   show_delete_confirmation: false
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addEvent(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               await api.fetchEndpoint({
                  resource: 'event',
                  action: 'add:event',
                  data: {
                     code: data.code,
                     alias: data.alias,
                     description: data.description,
                     fields: []
                  },
                  meta_data: {}
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchEventTables')
               ctx.commit('show_create_modal', false)
               $notify('success', 'Event Created', `Event ${data.code} successfully created.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async updateTable(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'update',
                  data: {
                     id: ctx.getters.selected_tables[0]._id,
                     record: {
                        alias: data.alias,
                        description: data.description,
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "table",
                  }
               })

               await ctx.dispatch('fetchEventTables')
               await payload.ref.resetForms()
               ctx.commit('show_edit_modal', false)
               $notify('success', 'Table Updated', `Table ${res.result.data.name} successfully updated.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteEvent(ctx,payload) {
         try {
            let data = payload.ref.form_data_
            
            if(data.name !== ctx.getters.selected_tables[0].name){
               $notify('error', 'Match Error', `The name provided does not match the table name.`, 5)
               return false
            }
            
            ctx.commit('loading', true)
            let res = await api.fetchEndpoint({
               resource: 'table',
               action: 'delete:table',
               data: {
                  table_id: ctx.getters.selected_tables[0]._id,
               },
               meta_data: {}
            })

            await payload.ref.resetForms()
            await ctx.dispatch('fetchEventTables')
            ctx.commit('show_delete_confirmation', false)
            $notify('success', 'Table Deleted', `<b>${res.result.table.name}</b> Table and <b>${res.result.field_count}</b> fields successfully deleted.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async handleActions(ctx, payload) {
         try {
            if (payload.action === 'table:edit') {
               Event.$emit('loader:show',true)
               let TableModel = ctx.getters.TableModel
               payload.rows[0].unique_field = payload.rows[0]?.configs?.unique_field
               TableModel.forms.editTable.data = payload.rows[0]
               
               ctx.commit('TableModel', TableModel)
               ctx.commit('show_edit_modal', true)
               ctx.commit('selected_tables', payload.rows)
               await ctx.dispatch('fetchTableFormFields',payload.rows[0].code)
               Event.$emit('loader:show',false)
            } else if (payload.action === 'table:view_fields') {
               ctx.getters.router.push({name: 'Table_Field', params: {table: payload.rows[0].code}})
               // $session.set('selected_tables',payload.rows[0])
            } else if (payload.action === 'table:fetch_data') {
               await ctx.dispatch('fetchTableDatabaseData',{table: payload.rows[0]})
            } else if (payload.action === 'table:delete') {
               ctx.commit('selected_tables', payload.rows)

               // Set placeholder to record being deleted
               let TableModel = ctx.getters.TableModel
               TableModel.forms.delete_table.subtitle = `Delete Event - <b>${payload.rows[0].name}</b>`
               ctx.commit('TableModel', TableModel)
               
               // Show the confirmation model
               ctx.commit('show_delete_confirmation', true)
            }
            
         } catch (error) {
            Event.$emit('loader:show',false)
         }
      },
      async fetchTableDatabaseData(ctx,payload) {
         try {
            // Fetch Schema
            await api.fetchEndpointSecure({
               resource: 'table',
               action: 'get:data',
               data: {
                  table_id: payload.table._id
               },
               meta_data: {}
            })

            $notify('success', 'Fetching Data', `Table ${payload.table.alias || payload.table.alias} data is being remotely fetched. You will receive a notification once this process is complete`, 10)
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            // Fetch Schema
            let res = await api.fetchEndpointSecure({
               resource: 'commons',action: 'list',
               data: {
                  rules: {
                     match: {
                        is_to_extract_data: true
                     }
                  }
               },
               meta_data: {service: "analytics",collection: "schema"}
            })


            let Model = utils.appendSelectData({
               Model: ctx.getters.TableModel,
               forms: ['filter_tables'],
               model: 'schema',
               label: 'name',
               dataField: 'code',
               data: res.result.records
            })
            ctx.commit('TableModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchTableFormFields(ctx,table) {
         try {
            // Fetch Table Fields
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        table_code: table
                     }
                  }
               },
               meta_data: { service: "analytics", collection: "field",}
            })


            let Model = utils.appendSelectData({
               Model: ctx.getters.TableModel,
               forms: ['editTable'],
               model: 'unique_field',
               label: 'name',
               dataField: 'name',
               data: res.result.records
            })
            ctx.commit('TableModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchEventTables(ctx) {
         try {
            let res = await api.fetchEndpoint({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        db_schema: "events"
                     }
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "table",
               }
            })

            ctx.commit('tables', res.result.records);
            Event.$emit('loader:show',false)
         } catch (err) {
            Event.$emit('loader:show',false)
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchFormData')
            await ctx.dispatch('fetchEventTables')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};